import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Event, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { Breadcrumb } from './breadcrumb.model';
import { BreadcrumbsService } from './breadcrumbs.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss']
})
export class BreadcrumbsComponent implements OnInit, OnDestroy {

  public breadcrumbs: any[] = [];
  private routeBreadcrumbParam: string = 'breadcrumb';
  private routeSubscription: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private breadcrumbsService: BreadcrumbsService
  ) { }

  ngOnInit() {
    this.routeSubscription = this.router.events
      .filter((event: Event) => event instanceof NavigationEnd)
      .subscribe((event: Event) => {
        const root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
      });

    this.breadcrumbs = this.getBreadcrumbs(this.activatedRoute.root);
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: any[] = []): any[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      if (child.outlet !== PRIMARY_OUTLET) {
        continue;
      }

      if (!child.snapshot.data.hasOwnProperty(this.routeBreadcrumbParam)) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      url += '/' + child.snapshot.url.map(segment => segment.path).join('/');
      const collectedBreadcrumbData: any = this.getBreadcrumbValue(child.snapshot);

      if (null === collectedBreadcrumbData) {
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      if ('' !== collectedBreadcrumbData) {
        breadcrumbs.push(this.getBreadcrumb(collectedBreadcrumbData, url));
      }

      return this.getBreadcrumbs(child, url, breadcrumbs);
    }
  }

  private getBreadcrumbValue(snapshot: ActivatedRouteSnapshot) {
    const breadcrumbData = snapshot.data['breadcrumb'];

    if ('function' === typeof breadcrumbData) {
      return breadcrumbData(snapshot, this.breadcrumbsService);
    }

    return breadcrumbData;
  }

  private getBreadcrumb(breadcrumbData: any, snapshotUrl: string): Breadcrumb {
    if (breadcrumbData instanceof Breadcrumb) {
      return breadcrumbData;
    }

    if ('string' === typeof breadcrumbData) {
      return new Breadcrumb(
          breadcrumbData,
          snapshotUrl
        );
    }

    return null;
  }
}



// WEBPACK FOOTER //
// /dist/src/app/ui/breadcrumbs/breadcrumbs.component.ts